<template>
  <div>
    <b-row class="d-flex align-items-center">
      <b-col cols="12">
        <h1 class="font-weight-bolder mb-0">Deposit Match Offers</h1>
      </b-col>
    </b-row>

 <b-row class="mt-1">
      <b-col cols="12" md="4">
        <b-card border-variant="secondary">
          <span class="d-block">Active Offers </span>
          <span class="d-block">4</span>
          <span class="d-block">Currently running</span>
        </b-card>
      </b-col>
      <b-col cols="12" md="4">
        <b-card border-variant="secondary">
          <span class="d-block">Average Match % </span>
      
          <span class="d-block"
            >100%</span
          >
          <span class="d-block">Across all offers</span>
        </b-card>
      </b-col>
      <b-col cols="12" md="4">
        <b-card border-variant="secondary">
          <span class="d-block">Redemption Rate</span>
          <span class="d-block">52%</span>
          <span class="d-block">Of eligible customers</span>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="8">
        <b-row>
          <b-col cols="12" md="3">
            <label for="From">From</label>
            <flat-pickr
              id="startDate"
              v-model="startDate"
              class="form-control"
              :config="configDate"
              placeholder="mm/dd/yyyy"
            />
          </b-col>
          <b-col cols="12" md="3">
            <label for="To">To</label>
            <flat-pickr
              id="endDate"
              v-model="endDate"
              class="form-control"
              :config="configDate"
              placeholder="mm/dd/yyyy"
            />
          </b-col>
          <b-col cols="12" md="3">
            <b-button
              @click="handleClearFilter"
              variant="outline-secondary"
              class="mt-2"
              >Clear Filter</b-button
            >
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="4" class="text-right justify-center">
        <b-link :to="{ name: 'promotions-deposit-match-new' }">
          <b-button size="md" variant="primary">
            <feather-icon icon="PlusIcon" />
            <span class="text-lg text-nowrap" style="margin-left: 4px"
              >New Deposit Match</span
            >
          </b-button>
        </b-link>
      </b-col>
    </b-row>

    <b-row class="mt-1">
      <b-col cols="12">
        <!-- <b-card> -->
        <b-table
          ref="refPromotionTable"
          class="mt-2"
          :items="fetchPromotionList"
          :fields="tableColumns"
          responsive
          show-empty
          primary-key="campaign"
        >
          <template #empty>
            <div v-if="loadingList" class="text-center text-dark my-2">
              <p>Loading... Please wait</p>
            </div>

            <div
              v-else-if="!loadingList && fetchPromotionList.length === 0"
              class="text-center text-dark my-2"
            >
              No matching records found
            </div>
          </template>

          <template #cell(date)="{ item }">
            <b-media vertical-align="center">
              <div class="d-flex align-items-center text-nowrap">
                {{ format(new Date(item.startTime), "yyyy-MM-dd") }}
              </div>
            </b-media>
          </template>
          <template #cell(expiry)="{ item }">
            <b-media vertical-align="center">
              <div class="d-flex align-items-center text-nowrap">
                {{ format(new Date(item.endTime), "yyyy-MM-dd") }}
              </div>
            </b-media>
          </template>
          <template #cell(name)="{ item }">
            <b-media vertical-align="center">
              <div class="d-flex align-items-center text-nowrap">
                {{ item.name }}
              </div>
            </b-media>
          </template>
          <template #cell(boostAllocated)="{ item }">
            <b-media vertical-align="center">
              <div class="d-flex align-items-center text-nowrap">
                {{ item.boostAllocated }}
              </div>
            </b-media>
          </template>
          <template #cell(category)>
            <b-media vertical-align="center">
              <div class="d-flex align-items-center text-nowrap">Racing</div>
            </b-media>
          </template>
          <template #cell(boostAmount)="{ item }">
            <b-media vertical-align="center">
              <div class="d-flex align-items-center text-nowrap">
                {{
                  item.discountType === "percent"
                    ? item.discountValue + "%"
                    : "$" + item.discountValue
                }}
              </div>
            </b-media>
          </template>

          <template #cell(type)="{ item }">
            <b-media vertical-align="center">
              <div class="d-flex align-items-center text-nowrap">
                {{ item.discountType === "mbs-bonus" ? "Bonus" : "Cash" }}
              </div>
            </b-media>
          </template>
          <template #cell(segments)="{ item }">
            <b-media vertical-align="center">
              <div class="d-flex align-items-center text-nowrap">
                {{ item.targets.map((i) => i.targetId).join(", ") }}
              </div>
            </b-media>
          </template>

          <template #cell(status)="{ item }">
            <b-media vertical-align="center">
              <div class="d-flex align-items-center text-nowrap">
                <b-form-checkbox
                  :checked="item.status === 'active'"
                  @click.native.prevent="handleCheckboxClick(item)"
                  switch
                />
              </div>
            </b-media>
          </template>

          <template #cell(actions)="{ item }">
            <b-media vertical-align="center">
              <div class="d-flex align-items-center">
                <feather-icon
                  size="16"
                  icon="EditIcon"
                  class="mr-1 text-primary cursor-pointer"
                  @click="
                    $router.push(`/promotions/deposit-match/${item.id}`)
                  "
                />
                <feather-icon
                  size="16"
                  icon="TrashIcon"
                  class="mr-1 text-danger cursor-pointer"
                  @click="showModal('delete', item)"
                />
              </div>
            </b-media>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">
                Showing {{ dataMeta.from }} to {{ dataMeta.to }} of
                {{ dataMeta.of }} offer(s)
              </span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalPromotions"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
        <!-- </b-card> -->
      </b-col>
    </b-row>

    <!-- MODAL CONFIRM -->
    <b-modal
      ref="modal"
      :title="modal.title"
      centered
      cancel-variant="outline-secondary"
      :ok-disabled="isSubmitting"
      @ok="handleSubmitModal"
    >
      <b-card-text style="color: black">
        {{ modal.content }}
      </b-card-text>
      <template #modal-ok>
        <Spinner v-if="isSubmitting" />
        <span v-else>Submit</span>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Spinner from "@core/components/Spinner";
import {
  BButton,
  BCard,
  BCol,
  BPagination,
  BRow,
  BButtonGroup,
  BTable,
  BCardBody,
  BFormInput,
  BMedia,
  BAvatar,
  BLink,
  BCardText,
  BFormCheckbox,
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import { computed, ref, watch } from "@vue/composition-api";
import useToastHandler from "@/services/toastHandler";
import { mapActions, mapState } from "vuex";
import { endOfDay, format, startOfDay } from "date-fns";

export default {
  components: {
    BButton,
    BCard,
    BRow,
    BCol,
    BTable,
    BMedia,
    BPagination,
    vSelect,
    Spinner,
    BButtonGroup,
    BTable,
    BCardBody,
    BFormInput,
    BAvatar,
    flatPickr,
    BLink,
    BCardText,
    BFormCheckbox,
  },
  data() {
    return {
      searchQuery: "",
      option: "Last 30 days",
      options: [
        { label: "Last 30 days", value: "last30days" },
        { label: "Last 7 days", value: "last7days" },
        { label: "Last 90 days", value: "last90days" },
      ],
      tableColumns: [
        { key: "date", label: "Date" },
        { key: "expiry", label: "Expiry" },
        { key: "name", label: "Name" },
        { key: "code", label: "Ref Code" },
        { key: "boostAllocated", label: "Refund Allocated" },
        { key: "category" },
        { key: "amount" },
        { key: "type" },
        { key: "segments" },
        { key: "position", label: "Internal Description" },
        { key: "redeemed" },
        { key: "status" },
        { key: "actions", label: "Actions" },
      ],
      configDate: {
        // dateFormat: 'd-m-Y',
        altFormat: "d-m-Y",
        altInput: true,
        static: true,
      },
      action: {
        type: "",
        item: "",
      },
      modal: {
        title: "",
        content: "",
      },
      updateStatusItem: null,
    };
  },
  computed: {
    ...mapState("promotions/list", ["loadingList", "loadingDeletePromotion",  "loadingCreatePromotion" ]),
    isSubmitting() {
      return this.loadingDeletePromotion || this.loadingCreatePromotion;
    },
  },
  methods: {
    ...mapActions({
      getPromotionsList: "promotions/list/getPromotionsList",
      deletePromotion: "promotions/list/deletePromotion",
      updatePromotion: "promotions/list/updatePromotion",
      getDetailPromotion: "promotions/list/getDetailPromotion",
    }),
    async fetchPromotionList() {
      const data = await this.getPromotionsList({
        page: this.currentPage,
        limit: this.perPage,
        type: "Deposit",
        ...(!!this.startDate &&
          !!this.endDate && {
            "date[startDate]": startOfDay(
              new Date(this.startDate)
            ).toISOString(),
          }),
        ...(!!this.startDate &&
          !!this.endDate && {
            "date[endDate]": endOfDay(new Date(this.endDate)).toISOString(),
          }),
      });
      this.totalPromotions = data.pagination.total;

      if (!data)
        return this.showToastError(
          false,
          "Error fetching promotion list"
        );
      return data.data.map((i) => {
        return {
          ...i,
          isActive: i.status === "active",
        };
      });
    },
    setModal(title, content) {
      this.modal.title = title;
      this.modal.content = content;
    },

    showModal(type, item) {
      this.action = { item, type };
      if (type === "delete") {
        this.setModal(
          "Delete Promotion",
          `Are you sure you want to delete the promotion ${item.name}?`
        );
      }
      if (type === "status") {
        this.setModal(
          "Update Status Promotion",
          `Are you sure you want to ${
            item.status === "active" ? "inactive" : "active"
          } the promotion ${item.name}?`
        );
        this.fetchDetailPromotion(item);
      }
      this.$refs.modal.show();
    },

    async handleSubmitModal(event) {
      event.preventDefault();
      const { item, type } = this.action;

      if (type === "delete") await this.handleDeletePromotion(item);
      if (type === "status") await this.handleChangeStatusPromotion(item);

      if (!this.isSubmitting) {
        this.$nextTick(() => {
          this.$refs.modal.hide();
        });
      }
    },
    async handleDeletePromotion(item) {
      const res = await this.deletePromotion(item.id);
      if (res) {
        this.showToastSuccess(true, "Promotion deleted successfully!");
        this.refetchData();
      }
    },
    handleCheckboxClick(item) {
      this.showModal("status", item);
    },
    async handleChangeStatusPromotion(item) {
      const res = await this.updatePromotion({
        promotionId: item.id,
        status: item.status === "active" ? "inactive" : "active",
        name: this.updateStatusItem.name,
        code: this.updateStatusItem.code,
        type: this.updateStatusItem.type,
        subType: this.updateStatusItem.subType,
        discountType: this.updateStatusItem.discountType,
        discountValue: this.updateStatusItem.discountValue,
        maxDiscount: this.updateStatusItem.maxDiscount,
        startTime: this.updateStatusItem.startTime.slice(0, -5),
        endTime: this.updateStatusItem.endTime.slice(0, -5),
      });
      if (res) {
        this.showToastSuccess(true, "Promotion updated successfully!");
        this.refetchData();
      }
    },
    handleClearFilter() {
      this.startDate = null;
      this.endDate = null;
      this.refetchData();
    },
    async fetchDetailPromotion(item) {
      const { data: data } = await this.getDetailPromotion(item.id);
      this.updateStatusItem = data;
    },
  },
  setup() {
    const refPromotionTable = ref(null);
    const totalPromotions = ref(0);
    const currentPage = ref(1);
    const perPage = ref(50);
    const startDate = ref(null);
    const endDate = ref(null);

    const dataMeta = computed(() => {
      const localItemsCount = refPromotionTable.value
        ? refPromotionTable.value.localItems.length
        : 0;
      return {
        from:
          perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: totalPromotions.value,
      };
    });

    const refetchData = () => {
      refPromotionTable.value.refresh();
    };

    watch([currentPage], () => {
      refetchData();
    });

    watch([startDate, endDate], () => {
      if (!!startDate.value && !!endDate.value) {
        refetchData();
      }
    });

    const { showToastError, showToastSuccess } = useToastHandler();

    return {
      showToastError,
      showToastSuccess,
      refPromotionTable,

      totalPromotions,
      currentPage,
      perPage,
      dataMeta,
      refetchData,

      format,

      startDate,
      endDate,
    };
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
